import styled from 'styled-components';

const StyledHamburgerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 67px;
  min-width: 67px;
  height: 100%;
`;

export default StyledHamburgerWrapper;
